import React, { createContext } from 'react';
import axios from 'axios';

export const AppContext = createContext();

export const AppProvider = (props) => {
    const getBolList = async () => {
        return await axios.get("/bol")
            .then(result => {
                return result.data;
            })
            .catch((ex) => {
                // if (ex.response && ex.response.status === 401) { setAuth(false) };
                return false;
            });
    }

    return (
        <AppContext.Provider value={{ getBolList }}>
            {props.children}
        </AppContext.Provider>
    )
}